import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Job } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';

@Injectable({
  providedIn: 'root',
})
export class JobService extends WorkflowDataService<Job> {
  protected override get apiEndpoint(): string {
    return '/jobs';
  }

  cancel(job: Job) {
    return this.http.post(
      `${this.baseUrl + this.apiEndpoint}/${job.id}/cancel`,
      {},
    );
  }

  addPriority(job: Job) {
    return this.http.post(
      `${this.baseUrl + this.apiEndpoint}/${job.id}/add-priority`,
      {},
    );
  }

  removePriority(job: Job) {
    return this.http.post(
      `${this.baseUrl + this.apiEndpoint}/${job.id}/remove-priority`,
      {},
    );
  }

  /**
   * Fetches a presigned S3 download URL for an imported CSV (workflow import).
   * Use when a job has an associated workflowImport (CSV import).
   */
  getWorkflowImportDownloadUrl(workflowImportId: string): Observable<string> {
    return this.http.get<string>(
      `${this.baseUrl}/workflow-import/${workflowImportId}/download-url`,
    );
  }

  export(
    dataConnectionIdentifier: string,
    dateRange: Date[],
    complete: boolean,
    deleted: boolean,
    cancelled: boolean,
    addWorker: boolean,
  ): Observable<{ content: string }> {
    let params = new HttpParams();
    params = params.append('dataConnectionIdentifier', dataConnectionIdentifier);
    params = params.append('from', this.formatDate(dateRange[0]));
    params = params.append('to', this.formatDate(dateRange[1]));
    params = params.append('complete', complete.toString());
    params = params.append('deleted', deleted.toString());
    params = params.append('cancelled', cancelled.toString());
    params = params.append('addLogistician', addWorker.toString());
    return this.http.get<{ content: string }>(`${this.baseUrl + this.apiEndpoint}/export`, { params });
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
